import { AgeGateComponent } from "./AgeGateComponent";
import { InstructionsComponent } from "./InstructionsComponents";
import { PostPermissionComponent } from "./PostPermissionComponent";

export function StyledLoaderComponent(props: any) {
  // There are two options with this.
  // It can be used in React.Suspense as fallback eg. <React.Suspense fallback={<StyledLoader />}>
  // In that case it will hide automatically once every child of React.Suspense has resolved

  // Or it can be a standalone component which fills the whole screen and is hidden once loading is complete.
  // Load complete is reflected in props.active === false

  // Below is the 2nd case

  // useEffect(() => {
  //   console.log("StyledLoaderComponent", props);
  // }, [props]);

  // eslint-disable-next-line no-lone-blocks
  {
    return (
      <>
        {props.instructionsEnded && (
          <div className="loadingText">
            <p>Loading</p>
            <div className="sk-chase">
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
              <div className="sk-chase-dot"></div>
            </div>
          </div>
        )}
      </>
    );
  }
}
